import type { IDealerStaticContent } from '@/components/sections/dealer';
import type { IDealerPanelContent } from '@/components/sections/dealer/panel/content';

const DEALER_PANEL_CONTENT: IDealerPanelContent = {
  addressLabel: 'ที่อยู่',
  googleMapButtonLabel: 'เปิดใน Google Map',
  showroom: {
    label: 'ข้อมูลโชว์รูม',
    sell: {
      label: 'จำหน่าย',
      icon: 'shop-store',
    },
    businessHours: {
      label: 'วันและเวลาทำการ',
      icon: 'schedule',
    },
    telephone: {
      label: 'โทรศัพท์',
      icon: 'local-phone',
    },
    messenger: {
      label: 'Messenger',
      icon: 'messenger',
    },
    line: {
      label: 'Line',
      icon: 'line',
    },
  },
  serviceCenter: {
    label: 'ข้อมูลศูนย์บริการ',
    service: {
      label: 'บริการ',
      icon: 'fix',
    },
    specialService: {
      label: 'บริการพิเศษ',
      icon: 'stars',
    },
    businessHours: {
      label: 'วันและเวลาทำการ',
      icon: 'schedule',
    },
    telephone: {
      label: 'โทรศัพท์',
      icon: 'local-phone',
    },
    telephoneAppointment: {
      label: 'โทรศัพท์นัดหมายล่วงหน้า',
      icon: 'local-phone',
    },
    line: {
      label: 'Line',
      icon: 'line',
    },
  },
};

export const STATIC_CONTENT: IDealerStaticContent = {
  message: 'กรุณากดเลือกค้นหา<br />โชว์รูมและศูนย์บริการ',
  title: 'โชว์รูม<span>และศูนย์บริการ</span>',
  description: 'ค้นหาโชว์รูมและศูนย์บริการอีซูซุใกล้บ้านคุณ',
  searchCurrentLocationButton: {
    label: 'ค้นหาจากตำแหน่งของคุณ',
    icon: 'my-location',
    tracking: {
      dataTrack: 'dealer_mylocation',
      dataTrackText: 'ค้นหาจากตำแหน่งของคุณ',
    },
    test: {
      dataTest: 'button_findYourLocation',
    },
  },
  imageDesktop: {
    src: 'https://images.contentstack.io/v3/assets/blt04fb7dc282801dd0/bltcac39e07e352b085/622824e489620a76c3a0d054/bg.jpg',
    alt: 'โชว์รูมและศูนย์บริการ',
    width: 1600,
    height: 686,
  },
  panel: DEALER_PANEL_CONTENT,
};

export const MOCK_PROVINCES = [
  { uid: 'blt9d2c2f50016107bb', name_th: 'ยะลา', province_id: '40' },
  { uid: 'blt32440de2bf92fe1a', name_th: 'น่าน', province_id: '24' },
  { uid: 'blt25357c84781932ea', name_th: 'พังงา', province_id: '33' },
  { uid: 'bltd632c4a003bae32f', name_th: 'ชุมพร', province_id: '12' },
  { uid: 'blt6b84d58a59095b7d', name_th: 'แพร่', province_id: '76' },
  { uid: 'blt91c3f6d42092b120', name_th: 'บึงกาฬ', province_id: '25' },
  { uid: 'blta03e902e2b33d179', name_th: 'เลย', province_id: '75' },
  { uid: 'blt25a4310e2e6326a2', name_th: 'พะเยา', province_id: '32' },
  { uid: 'bltb109a3e0c74cb7a4', name_th: 'ลำพูน', province_id: '48' },
];

export const MOCK_ALL_DEALER_DATA = [
  {
    uid: 'blt89bbcdc78412465c',
    aftersale: {
      service_center_tel: [
        {
          tel: '044611239 ',
          _metadata: {
            uid: 'cs41de202a5a859790',
          },
          ext: ' 3',
        },
      ],
      service_center_appointment_tel: [
        {
          tel: '044245577',
          _metadata: {
            uid: 'cs52d4b5182900f9e9',
          },
          ext: '',
        },
      ],
      service_center_hour_mon_fri: '08:30 - 17:30',
      service_center_hour_sat: '08:30 - 17:30',
      service_center_hour_sun: 'ปิดทำการ',
      service_cv: false,
      service_lcv: true,
      tire_changing_cv: false,
      tire_changing_lcv: true,
      body_paint_cv: false,
      body_paint_lcv: true,
      overhaul_cv: false,
      overhaul_lcv: true,
      line_service: '@kingyont',
      body_paint_branch_code: '40460305',
      body_paint_name_en: "King's Yont L.P. (Burirum)",
      body_paint_name_th: 'บริษัท คิงส์ยนต์ จำกัด (บุรีรัมย์)',
    },
    dealer_id: '186',
    mirai: {
      branch_code: '40460305',
      name_th: 'บริษัท คิงส์ยนต์ จำกัด  (สาขาบุรีรัมย์)',
      name_en: 'King s Yont CO., LTD',
      group_name: "King's Yont CO., LTD",
      company_name: 'บริษัท คิงส์ยนต์ จำกัด',
      address: '35/13-14 ถนนธานี ต.ในเมือง อ.เมือง จ.บุรีรัมย์ 31000',
      region: 'ตะวันออกเฉียงเหนือ',
    },
    sale: {
      show_room_cv: true,
      show_room_lcv: true,
      campaign_cv: false,
      campaign_lcv: true,
      lat: '14.998193458652613',
      lon: '103.10305291110026',
      email: 'sl_ky_co_hq@tripetch-isuzu.co.th',
      showroom_tel: [
        {
          tel: '044611239 ',
          _metadata: {
            uid: 'csc805ec49bee6b668',
          },
          ext: ' 1',
        },
      ],
      showroom_hour_mon_fri: '08:00 - 17:30',
      showroom_hour_sat: '08:00 - 17:30',
      showroom_hour_sun: 'ปิดทำการ',
      website: '',
      fb_sale_cv: 'kingyonttrucks',
      fb_sale_cv_name: 'รถบรรทุกอีซูซุคิงส์ยนต์',
      fb_sale_lcv: 'kingyont',
      fb_sale_lcv_name: 'อีซูซุคิงส์ยนต์',
      line_sale_cv: '@kingyont',
      line_sale_lcv: '@kingyont',
      google_map_url: '',
    },
  },
  {
    uid: 'blt948df97bca17c5c4',
    aftersale: {
      service_center_tel: [
        {
          tel: '44245577',
          _metadata: {
            uid: 'csa6c80afc8f90fdeb',
          },
          ext: '',
        },
      ],
      service_center_appointment_tel: [
        {
          tel: '044230527',
          _metadata: {
            uid: 'csf9774bfba05fbd4c',
          },
          ext: '',
        },
      ],
      service_center_hour_mon_fri: '08:30 - 17:30',
      service_center_hour_sat: '08:30 - 17:30',
      service_center_hour_sun: 'ปิดทำการ',
      service_cv: false,
      service_lcv: true,
      tire_changing_cv: false,
      tire_changing_lcv: true,
      body_paint_cv: false,
      body_paint_lcv: true,
      overhaul_cv: false,
      overhaul_lcv: true,
      line_service: '@kingyont',
      body_paint_branch_code: '',
      body_paint_name_en: '',
      body_paint_name_th: '',
    },
    dealer_id: '185',
    mirai: {
      branch_code: '40460304',
      name_th: 'บริษัท คิงส์ยนต์ จำกัด (สาขาสำนักงานใหญ่)',
      name_en: "King's Yont CO.,LTD",
      group_name: "King's Yont CO.,LTD",
      company_name: 'บริษัท คิงส์ยนต์ จำกัด',
      address: '403/1-5 ถนนมิตรภาพ ต.ในเมือง อ.เมือง จ.นครราชสีมา 30000',
      region: 'ตะวันออกเฉียงเหนือ',
    },
    sale: {
      show_room_cv: true,
      show_room_lcv: true,
      campaign_cv: true,
      campaign_lcv: true,
      lat: '14.980020620735715',
      lon: '102.08609737802189',
      email: 'sl_ky_co_hq@tripetch-isuzu.co.th',
      showroom_tel: [
        {
          tel: '044252581 ',
          _metadata: {
            uid: 'csda7f2bfd5eb6152c',
          },
          ext: ' 1',
        },
      ],
      showroom_hour_mon_fri: '08:00 - 17:30',
      showroom_hour_sat: '08:00 - 17:30',
      showroom_hour_sun: '09:00 - 16:00',
      website: '',
      fb_sale_cv: 'kingyonttrucks',
      fb_sale_cv_name: 'รถบรรทุกอีซูซุคิงส์ยนต์',
      fb_sale_lcv: 'kingyont',
      fb_sale_lcv_name: 'อีซูซุคิงส์ยนต์',
      line_sale_cv: '@kingyont',
      line_sale_lcv: '@kingyont',
      google_map_url: '',
    },
  },
  {
    uid: 'blt777d61b17d0f352c',
    aftersale: {
      service_center_tel: [
        {
          tel: '0882786217',
          _metadata: {
            uid: 'cs94dcfe9efa63ab86',
          },
          ext: '',
        },
        {
          tel: '036223901-4 ',
          _metadata: {
            uid: 'cs8ce188e3694c5ab1',
          },
          ext: ' 143',
        },
      ],
      service_center_appointment_tel: [
        {
          tel: '086 430 6529',
          _metadata: {
            uid: 'cs2f00babd9194c850',
          },
          ext: '',
        },
        {
          tel: '083 065 0832',
          _metadata: {
            uid: 'cs70c93c3df266dd2c',
          },
          ext: '',
        },
      ],
      service_center_hour_mon_fri: '08:00 - 17:00',
      service_center_hour_sat: '08:00 - 17:00',
      service_center_hour_sun: '08:00 - 17:00',
      service_cv: true,
      service_lcv: true,
      tire_changing_cv: false,
      tire_changing_lcv: true,
      body_paint_cv: false,
      body_paint_lcv: true,
      overhaul_cv: true,
      overhaul_lcv: true,
      line_service: '@ckh-isuzu',
      body_paint_branch_code: '40059101',
      body_paint_name_en: 'Chueng Kong Heng Isuzu Co., Ltd. (Saraburi-HQ)',
      body_paint_name_th:
        'บริษัท จึงกงเฮงอีซูซุ จำกัด (ศูนย์ซ่อมสีและตัวถังสระบุรี)',
    },
    dealer_id: '145',
    mirai: {
      branch_code: '40050101',
      name_th: 'บริษัท จึงกงเฮงอีซูซุ จำกัด  (สาขาสระบุรี)',
      name_en: 'Chueng Kong Heng Isuzu Co Ltd',
      group_name: 'Chueng Kong Heng Isuzu Co.,Ltd.',
      company_name: 'บริษัท จึงกงเฮงอีซูซุ จำกัด',
      address: '11 ถนนพหลโยธิน ต.ปากเพรียว อ.เมือง จ.สระบุรี 18000',
      region: 'ตะวันออกและกลางตอนบน',
    },
    sale: {
      show_room_cv: true,
      show_room_lcv: true,
      campaign_cv: true,
      campaign_lcv: true,
      lat: '14.508341',
      lon: '100.916901',
      email: 'sl_ckh_b_2@tripetch-isuzu.co.th',
      showroom_tel: [
        {
          tel: '036223901-4',
          _metadata: {
            uid: 'cs0adb13da06cdf43a',
          },
          ext: '',
        },
      ],
      showroom_hour_mon_fri: '08:00 - 17:00',
      showroom_hour_sat: '08:00 - 17:00',
      showroom_hour_sun: '08:00 - 17:00',
      website: '',
      fb_sale_cv: 'cheungkonhengisuzu',
      fb_sale_cv_name: 'สิบล้อ หกล้อ จึงกงเฮงอีซูซุ สระบุรี - ฝ่ายขาย',
      fb_sale_lcv: 'chuengkonghengisuzu2559',
      fb_sale_lcv_name: 'จึงกงเฮงอีซูซุ สระบุรี-ฝ่ายขาย',
      line_sale_cv: '',
      line_sale_lcv: '@ckh-isuzu',
      google_map_url: '',
    },
  },
];
